import { render, staticRenderFns } from "./QuotationPriceHistoryTable.vue?vue&type=template&id=4e085d82&"
import script from "./QuotationPriceHistoryTable.vue?vue&type=script&lang=js&"
export * from "./QuotationPriceHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports